export default __webpack_public_path__ + "static/media/add_video_icon_active.2d95d93f.svg";